import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
    GatewayNumberDto,
    SmsCampaignDefinitionInput,
    SmsCampaignProjectFilterDestinationInput,
} from "../../../api/psc";

export interface SmsCampaignExcelFileInput {
    fileId?: string;
    totalCount?: number;
}

export enum SmsCampaignType {
    CampaignWithProjectFilter = 1,
    CampaignWithExcelFile = 2,
    CampaignWithTestMobileNumbers = 3,
}

function getInitialStateForProjectFilter(): SmsCampaignProjectFilterDestinationInput {
    return {
        targetAccessId: null,
        cityIds: [],
        regionIds: [],
        phaseIds: [],
        subRegionIds: [],
        updateDateFrom: null,
        updateDateTo: null,
        structureTypeIds: [],
        usageTypesIds: [],
    };
}

export interface SmsCampaignState {
    definition: SmsCampaignDefinitionInput;
    mobileNumbers: string[];
    excelFile?: SmsCampaignExcelFileInput;
    projectFilter?: SmsCampaignProjectFilterDestinationInput;
    smsCampaignType?: SmsCampaignType;
    currentStep: number;
    gatewayNumbers?: GatewayNumberDto[];
}

const initialState: SmsCampaignState = {
    definition: {
        template: null,
        systemSmsTemplateId: null,
        systemSmsTemplateArguments: null,
        gatewayNumberId: null,
        scheduleDate: null,
    },
    mobileNumbers: [],
    excelFile: null,
    projectFilter: getInitialStateForProjectFilter(),
    smsCampaignType: null,
    currentStep: 0,
    gatewayNumbers: null,
};

const smsCampaignSlice = createSlice({
    name: "filterSmsCampaign",
    initialState,
    reducers: {
        setInitialState(state) {
            return { ...initialState };
        },
        setSmsCampaignType(
            state,
            action: PayloadAction<SmsCampaignType | null>
        ) {
            return {
                ...initialState,
                gatewayNumbers: state.gatewayNumbers,
                smsCampaignType: action.payload,
            };
        },
        setSmsCampaignDefinition(
            state,
            action: PayloadAction<SmsCampaignDefinitionInput>
        ) {
            return { ...state, definition: action.payload, mobileNumbers: [] };
        },
        setSmsCampaignExcelFile(
            state,
            action: PayloadAction<SmsCampaignExcelFileInput>
        ) {
            return { ...state, excelFile: action.payload };
        },
        setSmsCampaignPhoneNumbers(state, action: PayloadAction<string[]>) {
            return { ...state, mobileNumbers: action.payload };
        },
        setSmsCampaignProjectFilter(
            state,
            action: PayloadAction<SmsCampaignProjectFilterDestinationInput>
        ) {
            return { ...state, projectFilter: action.payload };
        },
        smsCampaignNextStep(state) {
            return { ...state, currentStep: state.currentStep + 1 };
        },
        smsCampaignPrevStep(state) {
            return { ...state, currentStep: state.currentStep - 1 };
        },
        setSmsCampaignGatewayNumbers(
            state,
            action: PayloadAction<GatewayNumberDto[]>
        ) {
            return { ...state, gatewayNumbers: action.payload };
        },
    },
});

export const {
    setInitialState,
    setSmsCampaignType,
    setSmsCampaignDefinition,
    setSmsCampaignExcelFile,
    setSmsCampaignPhoneNumbers,
    setSmsCampaignProjectFilter,
    smsCampaignNextStep,
    smsCampaignPrevStep,
    setSmsCampaignGatewayNumbers,
} = smsCampaignSlice.actions;
export default smsCampaignSlice.reducer;
